import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";

export default class LendingRepaymentPlansSettings extends BaseProductSettings {
}